<template>
    <div class="offer-row">
        <div class="offer-row__bar" @click="toggle">
            <h2
              class="offer-row__name">
                <span class="offer-row__star" v-if="offer.star">&#x2605; </span>
                <a
                  :href="offer.url"
                  target="_blank"
                >{{ offer.name }}</a>
                &nbsp;
                <span
                  class="offer-row__hotel-id"
                >({{ offer.type}} / {{ offer.hotelId }})</span>
            </h2>
            <span class="offer-row__location">{{ offer.country }} / {{ offer.region }}</span>
            <span class="offer-row__date">{{ offer.date | simpleDateRange }}</span>
            <span class="offer-row__last-price">
                <span
                  class="offer-row__last-price-value"
                >{{ lastPrice.price | formatPrice }}</span>
                <span
                  class="offer-row__last-price-date"
                 >{{ lastPrice.date | formatPriceDate }}</span>
            </span>
        </div>
        <div class="offer-row__details" v-show="isExpanded">
            <div class="offer-row__chart" ref="chart">
                <div class="offer-row__chart-container">
                    <canvas class="offer-row__chart-canvas" ref="chartCanvas"></canvas>
                </div>
            </div>
            <span class="offer-row__offer-id">{{ offer.id }}</span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Chart from 'chart.js';

export default {
  props: ['offer'],
  data() {
    return {
      isExpanded: false,
    };
  },

  computed: {
    lastPrice() {
      return this.offer.prices[0];
    },
    pricesForChart() {
      return this.offer.prices.map(price => ({
        x: price.date,
        y: price.price / 100,
      }));
    },
  },

  mounted() {
    // eslint-disable-next-line
    new Chart(this.$refs.chartCanvas, {
      type: 'line',
      data: {
        datasets: [{
          label: 'Cena',
          data: this.pricesForChart,
          borderWidth: 1,
          lineTension: 0,
        }],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              // beginAtZero:true,
            },
          }],
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
            },
          }],
        },
      },
    });
  },

  methods: {
    expand() {
      this.isExpanded = true;
    },

    collapse() {
      this.isExpanded = false;
    },

    toggle() {
      if (this.isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    },
  },

  filters: {
    simpleDateRange(dates) {
      return `${moment(dates.from).format('DD.MM')} - ${moment(dates.to).format('DD.MM')}`;
    },

    formatPriceDate(date) {
      return moment(date).format('DD.MM HH:mm:ss');
    },

    formatPrice(price) {
      return (price / 100).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });
    },
  },

};
</script>

<style lang="scss">
    .offer-row {
        &__name {
            display: inline-block;
            margin: 0;
            width: 40%;
            font-size: 1.2em;
        }

        &__hotel-id {
            font-size: 0.5em;
        }

        &__location {
            display: inline-block;
            width: 20%;
        }

        &__date {
            display: inline-block;
            width: 20%;
        }

        &__last-price {
            display: inline-block;
            width: 10%;
            text-align: right;
        }

        &__last-price-value {
            display: block;
        }

        &__last-price-date {
            font-size: 9px;
            display: block;
        }

        &__name,
        &__location,
        &__date,
        &__last-price {
            display: inline-block;
            vertical-align: middle;
        }

        &__bar {
            padding: 5px 0;
        }

        &__details {
            padding: 0 0 5px 0;
            position: relative;
        }

        &__chart {
            width: 100%;
            padding-bottom: 30%;
            position: relative;
        }

        &__chart-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        &__chart-canvas {
            width: 100%;
            height: 100%;
        }

        &__offer-id {
            font-size: 12px;
            margin-bottom: 1em;
            display: block;
        }
    }
</style>
